module.exports = __webpack_public_path__ + "img/icon_lock.a44cedfa.svg";